import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TableRow,
  Grid,
  Box,
  Button,
} from "@material-ui/core";
import {
  Toast,
  ConfirmationModal,
  AddLaboratory,
  EditLaboratory,
  SimpleToolbar,
  Loader,
  Drawer,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import { laboratoryServices, userServices, doctorServices } from "../services";
import { AuthContext } from "../context";
import { useDrawer } from "../hooks";
import {
  EditIconButton,
  EnableDisableIconButton,
  DeleteIconButton,
} from "../components/icon-buttons";

export default function UsersInLaboratoryScreen(props) {
  const classes = useStyles();
  const [users, setUsers] = useState([]);
  const { authState, signOut } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [userToEdit, setUserToEdit] = useState(null);
  const [openEditLaboratoryModal, setOpenEditLaboratoryModal] = useState(false);
  const [openAddLaboratoryModal, setOpenAddLaboratoryModal] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [userId, setUserId] = useState(null);
  const [reload, setReload] = useState(false);
  const [specialtiesList, setSpecialtiesList] = useState([]);
  const { isOpen, setIsOpen } = useDrawer();

  useEffect(() => {
    async function getLaboratories() {
      setReload(false);
      try {
        setLoading(true);
        const { status, response } =
          await laboratoryServices.getLaboratoryUsers({
            token: authState.token,
            laboratoryId: authState.user.laboratory._id,
          });
        setLoading(false);
        if (status === 200) {
          setUsers(response.users);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
    getLaboratories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState, reload]);

  useEffect(() => {
    async function init() {
      try {
        const { status, response } = await doctorServices.getSpecialties();
        if (status === 200) {
          setSpecialtiesList(response.specialties);
        } else if (status === 401) {
          signOut();
        }
      } catch (e) {
        console.log(e);
      }
    }
    init();
  }, [signOut]);

  const updateStatus = async (user) => {
    try {
      setLoading(true);
      const { status } = await userServices.updateUserStatus({
        status: !user.status,
        token: authState.token,
        _id: user._id,
      });
      setLoading(false);
      if (status === 200) {
        setReload(true);
        setToast(true);
        setToastMessage("Laboratorio actualizado con exito");
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const deleteLaboratory = async () => {
    try {
      setLoading(true);
      const { status, response } = await userServices.deleteUser({
        _id: userId,
        token: authState.token,
      });
      setLoading(false);
      if (status === 200) {
        setReload(true);
        setToast(true);
        setToastMessage(response.message);
      } else if (status === 401) {
        signOut();
      }
      if (response.error) {
        setToast(true);
        setToastMessage(response.error.message);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const handleClose = (value) => {
    setOpenEditLaboratoryModal(value);
    setUserToEdit(null);
  };

  const handleToast = (message, active) => {
    setToastMessage(message);
    setToast(active);
  };

  const confirmationModal = (_id) => {
    setOpenAlert(true);
    setUserId(_id);
  };

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container style={{ flex: 1 }}>
        {loading && <Loader loading={true} />}
        <Grid item sm={12} xs={12}>
          <div className={classes.root}>
            <ConfirmationModal
              open={openAlert}
              setOpenAlert={setOpenAlert}
              setConfirmAction={() => deleteLaboratory()}
            />
            <Toast
              message={toastMessage}
              open={toast}
              close={() => {
                setToast(false);
              }}
            />
            {openEditLaboratoryModal && (
              <EditLaboratory
                data={userToEdit}
                open={openEditLaboratoryModal}
                reload={() => setReload(true)}
                close={() => handleClose(false)}
                specialtiesList={specialtiesList}
                toast={(message, active) => handleToast(message, active)}
              />
            )}
            {openAddLaboratoryModal && (
              <AddLaboratory
                toast={(message, active) => {
                  handleToast(message, active);
                }}
                open={openAddLaboratoryModal}
                specialtiesList={specialtiesList}
                close={() => setOpenAddLaboratoryModal(false)}
                // departaments={props.departaments}
                reload={() => setReload(true)}
              />
            )}
            <Container maxWidth={false}>
              <SimpleToolbar
                // addButton
                // onAdd={() => setOpenAddLaboratoryModal(true)}
                // hideFilter
                // table={"tableUsers"}
                // filename={"Usuarios"}
                noSearchBar
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
              />
              <Box style={{ display: "flex", justifyContent: "end" , margin:'12px 0'}}>
                <Button
                  size="small"
                  color="primary"
                  variant="outlined"
                  onClick={() => setOpenAddLaboratoryModal(true)}
                >
                  Agregar
                </Button>
              </Box>
              <BaseTable tableId="tableUsers">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Usuario</StyledTableCell>
                    <StyledTableCell>Correo</StyledTableCell>
                    <StyledTableCell>Estado</StyledTableCell>
                    <StyledTableCell>Opciones</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map((user, index) => (
                    <StyledTableRow hover key={user._id}>
                      <StyledTableCell
                         
                      >
                        {user.username}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {user.email}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        {user.status ? "Activo" : "Inactivo"}
                      </StyledTableCell>
                      <StyledTableCell
                         
                      >
                        <EditIconButton
                          onClick={() => {
                            setOpenEditLaboratoryModal(true);
                            setUserToEdit(user);
                          }}
                          tooltipTitle="Editar"
                        />
                        <EnableDisableIconButton
                          onClick={() => updateStatus(user)}
                          status={user.status}
                          tooltipTitleEnable="Activar"
                          tooltipTitleDisable="Desactivar"
                        />
                        <DeleteIconButton
                          onClick={() => confirmationModal(user._id)}
                          tooltipTitle="Borrar Laboratorio"
                        />
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </BaseTable>
            </Container>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
}));
